import { FormEvent, useEffect, useState } from 'react'
import { XIcon } from '../icons'
import './ConfirmDialog.css'
import './TableNoteDialog.css'

/** Kolonun check'iyle aynı (supabase/masa-notu.sql). */
const MAX = 200

interface Props {
  /** "Bahçe 3" gibi, başlıkta. */
  tableLabel: string
  initial?: string
  onSave: (note: string) => void
  onClose: () => void
}

/**
 * Masa notu (4 Kas 2026): açık adisyona kısa bir not. Kasa da garson da
 * yazıyor; hesap kapanınca adisyonla birlikte gidiyor.
 */
export function TableNoteDialog({ tableLabel, initial = '', onSave, onClose }: Props) {
  const [value, setValue] = useState(initial)
  const trimmed = value.trim()
  const unchanged = trimmed === initial.trim()

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose()
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  const save = (note: string) => {
    onClose()
    onSave(note)
  }

  const submit = (e: FormEvent) => {
    e.preventDefault()
    if (unchanged) return onClose()
    save(trimmed)
  }

  return (
    <div className="dlg" role="dialog" aria-modal="true" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <form className="dlg__card dlg__card--x tnote" onSubmit={submit}>
        <button type="button" className="dlg__x" onClick={onClose} aria-label="Kapat">
          <XIcon />
        </button>
        <h2>Masa notu</h2>
        <p className="tnote__sub">{tableLabel}, hesap kapanınca not da silinir</p>

        <label className="dlgfield tnote__field">
          <span>Not</span>
          <textarea
            value={value}
            onChange={(e) => setValue(e.target.value.slice(0, MAX))}
            onKeyDown={(e) => {
              // Enter kaydeder, Shift+Enter alt satıra geçer.
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault()
                e.currentTarget.form?.requestSubmit()
              }
            }}
            placeholder="Notunuzu buraya girin"
            rows={3}
            autoFocus
          />
          <small className="tnote__count">
            {value.length}/{MAX}
          </small>
        </label>

        <div className="dlg__buttons dlg__buttons--even">
          {initial ? (
            <button type="button" className="btn btn--outline tnote__del" onClick={() => save('')}>
              Notu sil
            </button>
          ) : (
            <button type="button" className="btn btn--ghost" onClick={onClose}>
              Vazgeç
            </button>
          )}
          {/* Var olan not silinip Kaydet'e basılırsa not silinir; yeni notta
              boş Kaydet bir şey yapmaz. */}
          <button type="submit" className="btn btn--primary" disabled={unchanged || (!trimmed && !initial)}>
            Kaydet
          </button>
        </div>
      </form>
    </div>
  )
}
